"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTeamToggleDto = instanceOfTeamToggleDto;
exports.TeamToggleDtoFromJSON = TeamToggleDtoFromJSON;
exports.TeamToggleDtoFromJSONTyped = TeamToggleDtoFromJSONTyped;
exports.TeamToggleDtoToJSON = TeamToggleDtoToJSON;
exports.TeamToggleDtoToJSONTyped = TeamToggleDtoToJSONTyped;
/**
 * Check if a given object implements the TeamToggleDto interface.
 */
function instanceOfTeamToggleDto(value) {
    if (!('teamId' in value) || value['teamId'] === undefined)
        return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined)
        return false;
    return true;
}
function TeamToggleDtoFromJSON(json) {
    return TeamToggleDtoFromJSONTyped(json, false);
}
function TeamToggleDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'teamId': json['teamId'],
        'isEnabled': json['isEnabled'],
    };
}
function TeamToggleDtoToJSON(json) {
    return TeamToggleDtoToJSONTyped(json, false);
}
function TeamToggleDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'teamId': value['teamId'],
        'isEnabled': value['isEnabled'],
    };
}
